/*
 *   File : order.js
 *   Author : https://evoqins.com
 *   Description : Order card component
 *   Integrations : NA
 *   Version : 1.0.0
*/


import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

//Components
import { Icon } from "../Icon";

//custom style
import styles from "../../Style/Component/card.module.scss";

const OrderCard = (props) => {

    const navigate = useNavigate();

    const _formatAmount = (amount, toFixed) => {
        if (amount >= 10000000) {
            return (amount / 10000000).toFixed(toFixed ?? 0) + 'Cr'; // Crore
        } else if (amount >= 100000) {
            return (amount / 100000).toFixed(toFixed ?? 0) + 'Lakh'; // Lakh
        } else if (amount >= 1000) {
            return (amount / 1000).toFixed(toFixed ?? 0) + 'K'; // Thousand (K)
        } else {
            return amount ? amount.toString() : ""; // If less than 1000, return the number itself
        }
    }


    //handle navigate order detail 
    const _handleNavigateOrder = () => {
        navigate("order-detail", {
            state: {
                order_id: props.data.order_id
            }
        });
    };

    return (
        props.isCardView ?
            <div className={`${styles.e_fund_card_wrapper} ${props.selected?.order_id === props.data.order_id ? "e-border-1px-egyptian-blue" : "border-transparent"}  h-100 transition cursor-pointer e-bg-cultured p-3 e-border-radius-16`}
                onClick={props.onClickCard} >
                <div className={`${styles.e_fund_card} d-flex gap-2 align-items-center mb-3`}>
                    <img src={props.data.icon}
                        className="w-40px width-24px-res h-40 h-auto-res object-fit-contain e-bg-white p-1 e-border-radius-8"
                        draggable="false"
                        alt="fund" />
                    <h2 className="e-ellipse w-70 e-text-charleston-green e-primary-font-inter e-font-12-res  e-font-12-res-lg e-font-14 e-font-weight-500 line-height-20px mb-0">
                        {props.data.is_goal === true && props.data.basket_order === false ? `Life goal: ${props.data.name}` : `${props.data.basket_order ? props.data.basket_name : props.data.name} `}
                    </h2>
                    <span className="ms-auto e-text-charleston-green e-primary-font-inter e-font-12-res e-font-14-res-lg e-font-16 e-font-weight-600 line-height-20px">
                        {`₹${_formatAmount(props.data.amount, 0)}`}
                    </span>
                </div>
                <div className="d-flex  justify-content-between ms-xl-5 mb-3">
                    <div className="d-flex gap-3 flex-wrap row-gap-3">
                        {
                            props.data.tags.map((item, index) => (
                                <span key={index} className="text-nowrap e-text-html-css-gray e-primary-font-inter e-font-10-res e-font-12 e-font-weight-500 line-height-20px px-sm-2 px-1 e-border-radius-18 e-bg-white-marble">
                                    {item}
                                </span>
                            ))
                        }
                    </div>
                    <span className='text-nowrap e-text-neutral-navy e-primary-font-inter e-font-10-res e-font-12 e-font-weight-500 line-height-20px'>
                        {props.data.order_date}
                    </span>
                </div>

                <div className="d-flex justify-content-between mb-3">
                    {
                        props.data?.basket_order == true || props.data?.is_goal == true ?
                            <div className="col-auto d-flex flex-column">
                                <span className="e-text-dark-heather  e-font-12-res  e-font-14 e-primary-font-inter  e-font-weight-400 line-height-22px">
                                    Order date
                                </span>
                                <span className=" e-text-chinese-black  e-font-12-res e-font-14 e-primary-font-inter  e-font-weight-500 line-height-22px">
                                    {props.data.order_date}
                                </span>
                            </div>
                            :
                            <div className="col-auto d-flex flex-column">
                                <span className="e-text-dark-heather  e-font-12-res  e-font-14 e-primary-font-inter  e-font-weight-400 line-height-22px">
                                    Folio no
                                </span>
                                <span className=" e-text-chinese-black  e-font-12-res e-font-14 e-primary-font-inter  e-font-weight-500 line-height-22px">
                                    {props.data.folio_number}
                                </span>
                            </div>
                    }

                    <div className="col-auto d-flex flex-column text-end">

                        <span className="e-text-dark-heather  e-font-12-res  e-font-14 e-primary-font-inter  e-font-weight-400 line-height-22px">
                            Order ID
                        </span>
                        <span className=" e-text-chinese-black e-font-12-res  e-font-14 e-primary-font-inter  e-font-weight-500 line-height-22px">
                            {props.data.order_id}
                        </span>
                    </div>
                </div>
                {
                    props.data?.basket_order == false && props.data?.is_goal == false ?
                        <div className="d-flex justify-content-between mb-3">
                            <div className="col-auto d-flex flex-column">
                                <span className="e-text-dark-heather  e-font-12-res e-font-12-res  e-font-14 e-primary-font-inter  e-font-weight-400 line-height-22px">
                                    NAV
                                </span>
                                <span className=" e-text-chinese-black e-font-12-res e-font-12-res  e-font-14 e-primary-font-inter  e-font-weight-500 line-height-22px">
                                    {props.data.nav ? `₹${props.data.nav}` : "-"}
                                </span>
                            </div>
                            <div className="col-auto d-flex flex-column text-end">
                                <span className="e-text-dark-heather  e-font-12-res e-font-14 e-primary-font-inter  e-font-weight-400 line-height-22px">
                                    Units
                                </span>
                                <span className=" e-text-chinese-black e-font-12-res e-font-14 e-primary-font-inter  e-font-weight-500 line-height-22px">
                                    {props.data?.units_allocated_on || "-"}
                                </span>
                            </div>
                        </div>
                        :
                        null
                }


                {/* border */}
                <div className={styles.e_border_bottom}></div>

                <div className="d-flex flex-wrap justify-content-between mt-3">
                    <div className="col-auto d-flex flex-column">
                        <span className="e-text-dark-heather e-font-12-res  e-font-14 e-primary-font-inter  e-font-weight-400 line-height-22px">
                            Payment status
                        </span>
                        <p className={`${props.data.payment_status === "Failed" ? 'e-text-sunset-orange' : props.data.payment_status === "Pending" ? "e-text-mustard-yellow" : 'e-text-bottle-green'} mb-0 e-font-12-res e-font-14 e-primary-font-inter  e-font-weight-600 line-height-22px`}>
                            {props.data.payment_status}
                        </p>
                    </div>
                    <div className="col-auto d-flex flex-column text-end text-sm-start text-lg-end">
                        <span className="e-text-dark-heather e-font-12-res  e-font-14 e-primary-font-inter  e-font-weight-400 line-height-22px">
                            Order status
                        </span>
                        <p className={`${props.data.order_status === "Failed" ? 'e-text-sunset-orange' : props.data.order_status === "Pending" ? "e-text-mustard-yellow" : 'e-text-bottle-green'} mb-0 e-font-12-res e-font-14 e-primary-font-inter  e-font-weight-600 line-height-22px`}>
                            {props.data.order_status}
                        </p>
                    </div>
                </div>

                {
                    props.data?.failure_reason ?
                        <p className='mt-3 e-bg-calming-baby-pink-60  e-border-radius-4  px-2 py-1 mb-0 e-text-charleston-green e-font-10 e-primary-font-inter  e-font-weight-400 line-height-16px'>
                            {props.data?.failure_reason}
                        </p>
                        :
                        ""
                }


            </div>
            :
            <div className={`${styles.e_fund_card_wrapper} ${props.selected?.order_id === props.data.order_id ? "e-border-1px-egyptian-blue" : "border-transparent"}  h-100 transition cursor-pointer e-bg-cultured p-3 e-border-radius-16`}
                onClick={props.onClickCard} >
                <div className={`${styles.e_fund_card} d-flex gap-3 align-items-center mb-3`}>
                    <img src={props.data.icon}
                        className="w-40px width-24px-res h-40 h-auto-res object-fit-contain e-bg-white p-1 e-border-radius-8"
                        draggable="false"
                        alt="fund" />
                    <h2 className="e-ellipse e-text-charleston-green e-primary-font-inter e-font-12-res e-font-14 e-font-weight-500 line-height-20px mb-0">
                        {props.data.is_goal === true && props.data.basket_order === false ? `Life goal: ${props.data.name}` : `${props.data.basket_order ? props.data.basket_name : props.data.name} `}
                    </h2>
                    <span className="ms-auto e-text-charleston-green e-primary-font-inter e-font-12-res e-font-16 e-font-weight-600 line-height-20px">
                        {`₹${_formatAmount(props.data.amount, 0)}`}
                    </span>
                </div>
                <div className="d-flex justify-content-between  align-items-center ms-sm-5">
                    <div className="d-flex gap-3">
                        {
                            props.data.tags.map((item, index) => (
                                <span key={index} className="e-text-html-css-gray e-primary-font-inter e-font-10-res e-font-12 e-font-weight-500 line-height-20px px-sm-2 px-1 e-border-radius-18 e-bg-white-marble">
                                    {item}
                                </span>
                            ))
                        }
                    </div>
                    <div className="d-flex gap-1 align-items-center">
                        <span className='e-text-neutral-navy e-primary-font-inter e-font-10-res e-font-12 e-font-weight-500 line-height-16px'>
                            {props.data.order_date}
                        </span>
                        <span className={`${props.data.payment_status === "Failed" ? 'e-text-sunset-orange' : props.data.payment_status === "Pending" ? "e-text-mustard-yellow" : 'e-text-bottle-green'} mb-0 e-font-10-res e-font-14 e-primary-font-inter  e-font-weight-500 line-height-16px`}>
                            {props.data.payment_status}
                        </span>
                    </div>
                </div>
            </div>

    )
}

export default OrderCard;